import React, { Component } from 'react'
import './style.css'

class Activism extends Component {
  render () {
    return (
      <div className='books-main-container'>
        <div className='books-title-div'>
          <h1 className='books-main-title'>Activism</h1>
          <img src='https://i.imgur.com/y7U8Hoh.png' className='car-photo-activism' alt='' />
        </div>
        <div className='books-container' />
      </div>
    )
  }
}

export default Activism

// https://i.imgur.com/1KMe3ta.png
